import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconVoiceover: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVoiceover"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Path d="M8 14.5V9.5H10L11.5 7.5H13V16.5H11.5L10 14.5H8Z" fill="currentColor"/><Path d="M14.25 14.5C15.9167 13.25 15.9167 10.75 14.25 9.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconVoiceover;
